import axios from "axios";

const BASE_URL = "https://lms.childinfo.in/api";

export const getTopics = async (token) => {
  return axios.get(`${BASE_URL}/topics.php`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
